import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { contextapi } from "./helpers/contextapi";
import Modal from "react-modal";
import Login from "./pages/Login";
import ChangePassword from "./pages/ChangePassword";
import Forgot from "./pages/Forgot";
import NotFound from "./pages/NotFound";
import Dashboard from "./pages/Dashboard";
import Payment from "./pages/Payment";
import ProtectedRoute from "./helpers/ProtectedRoute";
import Registration from "./pages/Registration";
import Results from "./pages/Results";
import Attendance from "./pages/Attendance";
import Materials from "./pages/Materials";
import { ToastContainer } from "react-toastify";
import NewFee from "./pages/NewFee";
import VerifyPayment from "./components/VerifyPayment";
import NewCourse from "./pages/NewCourse";
import VerifyWallet from "./components/VerifyWallet";
import WalletTransaction from "./pages/WalletTransaction";
import { Receipt as WalletReceipt } from "./pages/WalletTransaction/Receipt";
import Registered from "./pages/Registered";
import Notifications from "./pages/Notifications";
import PrintResult from "./pages/PrintResult";
import ChangeProgramme from "./pages/ChangeProgramme";
import ModuleForm from "./pages/ModuleForm";
import PrintRegistration from "./pages/PrintRegistration";
import PaymentReceipt from "./pages/PaymentReceipts";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "react-toastify/dist/ReactToastify.css";
import Finance from "./pages/Finance";
import Academic from "./pages/Academic";
import { axiosget } from "./helpers/httprequest";
import HostelBooking from "./pages/HostelBooking";
import OtherPayments from "./pages/OtherPayments";
import Progression from "./pages/Progression";
import Resources from "./pages/Resources";
import useAuthStore from "./stores/useAuthStore";
import Impersonate from "./pages/Impersonate";
import ProfileEdit from "./pages/ProfileEdit";

Modal.setAppElement("#root");

const queryClient = new QueryClient();

const App = () => {
  const [values, setvalues] = React.useState({ settings: {}, officials: [] });
  const { setSettings, setOfficials } = useAuthStore();

  React.useEffect(() => {
    (async () => {
      try {
        const [settingsReq, officialsReq] = await Promise.all([
          axiosget("ms_system_settings/public"),
          axiosget("ms_officials")
        ]);

        const newSettings = (settingsReq?.status === 200 && !settingsReq.data?.type) ? settingsReq.data : {};
        const newOfficials = (officialsReq?.status === 200 && !officialsReq.data?.type) ? officialsReq.data : [];

        // Update both Context (backward compat) and Zustand store
        setvalues(prev => ({
          ...prev,
          settings: newSettings || prev.settings,
          officials: newOfficials || prev.officials,
        }));

        if (newSettings) setSettings(newSettings);
        if (newOfficials) setOfficials(newOfficials);
      } catch (error) {
        console.error("Failed to fetch university info", error);
      }
    })();
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <React.StrictMode>
        <contextapi.Provider value={{ values, setvalues }}>
          <Router>
            <Routes>
              <Route exact path="/" element={<Login />} />
              <Route exact path="/forgot" element={<Forgot />} />
              <Route exact path="/impersonate" element={<Impersonate />} />
              <Route exact path="/verify-payment" element={<VerifyPayment />} />
              <Route exact path="/verify-wallet" element={<VerifyWallet />} />
              <Route exact path="/payment-receipt/:id" element={<PaymentReceipt />} />
              <Route exact path="/wallet-receipt/:reference" element={<WalletReceipt />} />
              <Route exact path="/app/" element={<ProtectedRoute />}>
                <Route exact path="academic" element={<Academic />} />
                <Route exact path="dashboard" element={<Dashboard />} />
                <Route exact path="module-form" element={<ModuleForm />} />
                <Route exact path="finance" element={<Finance />} />
                <Route exact path="wallet-transaction" element={<WalletTransaction />} />
                <Route exact path="hostel-booking" element={<HostelBooking />} />
                <Route exact path="other-payments" element={<OtherPayments />} />
                <Route exact path="notifications" element={<Notifications />} />
                <Route exact path="registered-modules" element={<Registered />} />
                <Route exact path="payment" element={<Payment />} />
                <Route exact path="new-fee" element={<NewFee />} />
                <Route exact path="new-registration" element={<NewCourse />} />
                <Route exact path="materials" element={<Materials />} />
                <Route exact path="resources/:id" element={<Resources />} />
                <Route exact path="change" element={<ChangePassword />} />
                <Route exact path="registration" element={<Registration />} />
                <Route exact path="print-registration/:id" element={<PrintRegistration />} />
                <Route exact path="attendance" element={<Attendance />} />
                <Route exact path="result" element={<Results />} />
                <Route exact path="progression" element={<Progression />} />
                <Route exact path="change-programme" element={<ChangeProgramme />} />
                <Route exact path="print-result/:id" element={<PrintResult />} />
                <Route exact path="profile/edit" element={<ProfileEdit />} />
              </Route>
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Router>
        </contextapi.Provider>
        <ToastContainer />
      </React.StrictMode>
    </QueryClientProvider>
  );
};

export default App;
